import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_payment_expense",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "title-h4" }
const _hoisted_10 = { class: "row mb-5" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-1 mt-1" }
const _hoisted_13 = { class: "d-inline-block w-160" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-1 mt-1" }
const _hoisted_16 = { class: "d-inline-block w-160" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-1 mt-1" }
const _hoisted_19 = { class: "d-inline-block w-160" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-1 mt-1" }
const _hoisted_22 = { class: "d-inline-block w-160" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-1 mt-1" }
const _hoisted_25 = { class: "d-inline-block w-160" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-1 mt-1" }
const _hoisted_28 = { class: "d-inline-block w-160" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group mr-b-0em" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_35 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_36 = { class: "form-group mr-b-0em" }
const _hoisted_37 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_38 = { class: "form-group mr-b-0em" }
const _hoisted_39 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_40 = { class: "form-group mr-b-0em" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group mr-b-0em" }
const _hoisted_43 = { class: "col-12 text-right" }
const _hoisted_44 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_price_input = _resolveComponent("price-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestPayment)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.title')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_add_payment_expense', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestPaymentExpense)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.info')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.i18n.t('tables.expense.title')), 1),
                      _createTextVNode(": " + _toDisplayString(_ctx.expense?.title ?? ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("b", _hoisted_16, _toDisplayString(_ctx.i18n.t('tables.expense.category_name')), 1),
                      _createTextVNode(" : "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.expense?.service?.category?.name ?? ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("b", _hoisted_19, _toDisplayString(_ctx.i18n.t('tables.expense.service_name')), 1),
                      _createTextVNode(": "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.expense?.service?.name ?? ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("b", _hoisted_22, _toDisplayString(_ctx.i18n.t('tables.expense.total_amount')), 1),
                      _createTextVNode(" : " + _toDisplayString(_ctx.expense?.total_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("b", _hoisted_25, _toDisplayString(_ctx.i18n.t('tables.expense.total_amount_paid')), 1),
                      _createTextVNode(" : " + _toDisplayString(_ctx.expense?.total_amount_paid ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("b", _hoisted_28, _toDisplayString(_ctx.i18n.t('tables.expense.remaining_amount')), 1),
                      _createTextVNode(" : " + _toDisplayString(_ctx.expense?.remaining_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                    ])
                  ])
                ]),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_date_field, {
                        modelValue: _ctx.requestPaymentExpense.paymentDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestPaymentExpense.paymentDate) = $event)),
                        label: _ctx.i18n.t('tables.payment.paymentDate'),
                        v: _ctx.v$.paymentDate,
                        disabled: false,
                        fixedDays: 1,
                        isFixedDays: true
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_SingleSelect, {
                      TextLabel: _ctx.i18n.t('tables.payment.paymentMethod'),
                      trackby: `id`,
                      label: `name`,
                      valueProp: `id`,
                      modelValue: _ctx.requestPaymentExpense.paymentMethod,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestPaymentExpense.paymentMethod) = $event)),
                      placeholder: _ctx.i18n.t('tables.payment.paymentMethod'),
                      arrayOptions: _ctx.payment_methodsList,
                      refs: "paymentMethod",
                      v: _ctx.v$.paymentMethod
                    }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                  ]),
                  (_ctx.requestPaymentExpense.paymentMethod === 'Chèque bancaire')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.payment.bankName'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestPaymentExpense.bankName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestPaymentExpense.bankName) = $event)),
                          placeholder: _ctx.i18n.t('tables.payment.bankName'),
                          arrayOptions: _ctx.bank_namesList,
                          refs: "bankName",
                          v: _ctx.v$.bankName
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requestPaymentExpense.paymentMethod === 'Chèque bancaire')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestPaymentExpense.chequeName,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestPaymentExpense.chequeName) = $event)),
                            label: _ctx.i18n.t('tables.payment.chequeName'),
                            v: _ctx.v$.chequeName,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requestPaymentExpense.paymentMethod === 'Chèque bancaire')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestPaymentExpense.chequeNum,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestPaymentExpense.chequeNum) = $event)),
                            label: _ctx.i18n.t('tables.payment.chequeNum'),
                            v: _ctx.v$.chequeNum,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.requestPaymentExpense.paymentMethod === 'Chèque bancaire')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_date_field, {
                            modelValue: _ctx.requestPaymentExpense.dueDate,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestPaymentExpense.dueDate) = $event)),
                            label: _ctx.i18n.t('tables.payment.dueDate'),
                            v: _ctx.v$.dueDate,
                            disabled: false,
                            fixedDays: 1,
                            isFixedDays: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_price_input, {
                        modelValue: _ctx.requestPaymentExpense.amount_paid,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestPaymentExpense.amount_paid) = $event)),
                        label: _ctx.i18n.t('tables.payment.amount_paid'),
                        v: _ctx.v$.amount_paid,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emptyState())),
                    class: "btn btn-cancel"
                  }, _toDisplayString(_ctx.i18n.t('button.cancel')), 1)
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}